import React, { Component } from 'react'
import GoToDownloadButton from './GoToDownloadButton'
import { FormattedMessage } from 'react-intl'

class TitleSection extends Component {
  render() {
    return (
      <div className="w-100 mt3">
        <div className="img">
          <img src="images/title-image.png" alt="img" />
        </div>
        <div className="abs-pos bg-w">
          <div className="title mt2"> Insights</div>
          <div className="text-color f6 f3-ns mt3 slogan-width">
            <FormattedMessage id="titlePage.slogan" />
          </div>
          <div className="mt4 mt5-ns">
            <GoToDownloadButton />
          </div>
        </div>
      </div>
    )
  }
}

export default TitleSection



// WEBPACK FOOTER //
// ./src/components/TitleSection.js